import Model from './Model'

export default class Report extends Model {
  resource() {
    return 'reports'
  }
}
